<template>
  <div>
    <div id="wrapper">
      <div id="inziCamera"></div>
      <button @click="takePhoto" class="next-button">
        {{ "신분증 확인하기" }}
      </button>
      {{ res }}
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  mounted() {
    $(document).ready(function() {
      inzicamera.initModule($("#inziCamera"));
    });
  },
  data() {
    return {
      res: {},
    };
  },
  methods: {
    successCallback(image_data) {
      this.requestOcr(image_data);
    },
    failedCallback(error) {
      this.requestOcr(error);
    },
    takePhoto() {
      inzicamera.startTakingPhoto(this.successCallback, this.failedCallback);
    },
    async requestOcr(image_data) {
      var formData = new FormData();
      formData.append("taskId", "Main");
      formData.append("formInfo", "IDCARD");
      formData.append("srcFile", image_data.blob);
      formData.append("maskingImage", true);
      formData.append("cropImage", true);

      try {
        const res = await axios.post(
          "https://ocr.dev.flybit.com/api/ocr",
          formData,
          {
            headers: {
              "Content-Type": "Multipart/form-data",
            },
          },
        );
        this.res = res;
        console.log(res);
        if (res.data.resultCode == "200") {
          this.$vs.notify({
            title: "안내",
            text: `신분증 확인이 완료 되었습니다.`,
            position: "top-right",
            color: "success",
          });
        } else {
          this.$vs.notify({
            title: "오류",
            text: `신분증을 인식하지 못했습니다. 다시 시도해 주세요.`,
            position: "top-right",
            color: "danger",
          });
          return;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
